import React, { Component } from 'react'; 
import {Row, Col, Table} from 'react-bootstrap';
import _ from 'lodash';


export default class ReadOnlyScreen extends Component {
  constructor(props){
    super(props)
    this.state={      
      toggle:true,
      toggleI:true,
      toggleF:false,
      toggleS:false
    }
    this.copyData = [];
    this.isRating=false;
    this.isRatingYes=false;
    this.isNCReason1=false;
    this.isNCReason2=false;
    this.isNCReason3=false;
    this.isNCReason4=false;
    this.isNCReason5=false;
  }
  componentDidMount(){
    const{auditorJson} = this.props   
    this.createTemplate(auditorJson.templateValue.Parameters)    
  }  
  createTemplate = (json) => {
    let templateObj = [];
    _.map(json, (obj, paramindex) => {
      _.map(obj.attributes, (val, index) => {
        _.map(val.questions, (next, questindex) => {
          _.map(next.Scoring, (tt, scoreindex) => {
            let tempTemplateObj = {};
            let isParamDisable = ((paramindex < index) || (index < questindex)) ? true : false;
            let isAttribDisable = (index < questindex) ? true : false;
            tempTemplateObj.key = 'K' + templateObj.length
            tempTemplateObj.Parameters = {};
            tempTemplateObj.Parameters.id = "Parameters";
            tempTemplateObj.Parameters.value = obj;
            tempTemplateObj.Parameters.disabled = isParamDisable;
            tempTemplateObj.Attributes = {};
            tempTemplateObj.Attributes.id = "Attributes";
            tempTemplateObj.Attributes.value = val;
            tempTemplateObj.Attributes.disabled = isAttribDisable;
            tempTemplateObj.Questions = {};
            tempTemplateObj.Questions.id = "Questions";
            tempTemplateObj.Questions.value = next;
            tempTemplateObj.Scoring = {};
            tempTemplateObj.Scoring.id = "Scoring";
            tempTemplateObj.Scoring.value = tt;
            templateObj.push(tempTemplateObj);
            if(tt.textRating === true){
              this.isRatingYes=true
            } else {
              this.isRating = true
            }
            if(tt.NCReason1 === true){
              this.isNCReason1=true
            } 
            if(tt.NCReason2 === true){
              this.isNCReason2=true
            } 
            if(tt.NCReason3 === true){
              this.isNCReason3=true
            } 
            if(tt.NCReason4 === true){
              this.isNCReason4=true
            } 
            if(tt.NCReason5 === true){
              this.isNCReason5=true
            } 
          });
        });
      });
    });
    this.setState({ templateObj});
  }
  renderDocument(fieldValue){
    if(!_.isEmpty(fieldValue)){
      let firstObject=[]; let secondObject=[]; let thirdObject=[]
      let n = fieldValue.length;
      _.map(fieldValue, (obj, i)=>{  
        (i < n/3)  ? 
          firstObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>) : (i < 2*n/3) ?
          secondObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>) :
          thirdObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>)       
        })
        
       let returnObj = (   
          <Row className='information'>
          <Col>{firstObject}</Col>
          <Col>{secondObject}</Col>
          <Col>{thirdObject}</Col>
          </Row>)
      return returnObj
       }
  }
  renderBody = () =>{
    const {templateObj} = this.state;  
    if(templateObj && templateObj.length > 0) {
      return _.map(templateObj, (row, rowIndex) => {
        let Scores = row.Scoring.value
        let Selected = this.props.auditorJson.templateValue.Readonly.Scores[rowIndex];
        return (
          <tr key={row.key}>
            <td>{row.Parameters.value.label}</td>
            <td>{row.Attributes.value.label === 'null' ? '' : row.Attributes.value.label}</td>
            <td>{row.Questions.value.label === 'null' ? '' : row.Questions.value.label}</td>
            
              <td>
              <label><center>{Scores.weight}</center></label> </td>
              <td>
              {(Scores.NA) ?<label>{Selected.NA ? 'Yes' : "No"}</label> : ''}  </td>            
              {this.isRatingYes  ?<td>
              {(Scores.textRating && !(Selected.NA)) ? 
              <label>{ Selected.textrating}</label> 
              :''}</td> : null}
              {this.isRating  ? <td>
              {(!(Selected.NA)) ? 
                <label>{Selected.rating}</label> 
               :''}
              </td> : null}
              <td>
              {(Scores.Fatal) ? <label>{Selected.Fatal ? 'Yes' : "No"}</label> :'' }</td>
              {this.isNCReason1 ?  <td>{(Scores.NCReason1) ? <label>{Selected.NCReason1}</label> : '' }</td> : null}
              {this.isNCReason2 ?  <td>{(Scores.NCReason2) ? <label>{Selected.NCReason2}</label> : '' }</td> : null}                    
              {this.isNCReason3 ? <td>{(Scores.NCReason3) ? <label>{Selected.NCReason3}</label> : '' }</td>: null}
              {this.isNCReason4 ?  <td>{(Scores.NCReason4) ? <label>{Selected.NCReason4}</label> : '' }</td>: null}
              {this.isNCReason5 ? <td>{(Scores.NCReason5) ? <label>{Selected.NCReason5}</label> : '' }</td>: null}
              <td><label>{Selected.feedback}</label></td>
            
           
          </tr>
        )
      });
    }
    return (
      <tr className=""><td colSpan="5">No Records found.</td></tr>
    );

  }
  handleScoreCalculation = () =>{
    this.setState((prevState) =>{
      return {toggleS: !prevState.toggleS};
    })
  }
  ScoreCalculation = (data) => {
  let returnObj = [];
     _.map(data.scoreCalculation, (obj, t) => {        
        let paramfinal = 0;
        let final =1; 
        _.map(obj.qualityAttrList, (tt, i) =>{           
           paramfinal = paramfinal+(tt.scoreAttributes).length           
        })
       _.map(obj.qualityAttrList, (tt, i) =>{        
        final = tt.scoreAttributes.length 
        _.map(tt.scoreAttributes, (zz, index) =>{ 
        let className=""
        if(index <=  _.findLastIndex(tt.scoreAttributes)){
          if(t % 2 === 0){
            className='colorEven'
          } else{
            className='colorOdd'
          }          
        }        
        returnObj.push(
           <tr className={className} > 
             <td>{obj.qualityParam}</td>
             <td>{tt.qualityAttribute}</td>
             <td>{zz.qualityParam}</td>
             <td>{zz.maxScore}</td>
             <td>{zz.actualScore}</td>
             <td>{zz.paramScore}</td>    
             {index === 0 ? <td rowspan={final} className='NoVertical'>{tt.attScore}</td> : null}
             {(index === 0 && i === 0) ? <td rowspan={paramfinal} className='NoVertical'>{obj.parameterScore}</td> : null}
           </tr>)
       })
       })       
    }) 
  returnObj.push(<tr><td></td><td></td><th>Overall Score</th><th>{data.overallMaxScore}</th>
    <th>{data.overallActualScore}</th><th colspan="3">{data.overallAttributeScore}</th>      
    </tr>)
  returnObj.push(<tr><td></td><td></td><th>Overall Score Without Fatal</th><th>{data.maxScoreFatal}</th>
    <th>{data.actualScoreFatal}</th><th colspan="3">{data.overallScoreFatal}</th>      
    </tr>) 
   return returnObj
  }
 

  handleAssesment = () =>{
    this.setState((prevState) =>{
      return {toggle: !prevState.toggle};
    })
  }
  
  handleFeedbackToggle = () =>{
    this.setState((prevState) =>{
      return {toggleF: !prevState.toggleF};
    })
  }
  handleInformation = () =>{
    this.setState((prevState) =>{
      return {toggleI: !prevState.toggleI};
    })
  }
 
  
  render(){
    const{toggle, toggleF, toggleI, toggleS}= this.state;
    return(
      <div>  
         <h6 className={toggleI ? 'evalFormMargin': 'evalForm'} onClick={this.handleInformation} >
        {toggleI ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} INFORMATION</h6>  
        <div className={toggleI ? 'assesmentShow': 'assesmentHide'}>            
        {this.renderDocument(this.props.fieldValue)}  </div>
        <h6 className={toggle ? 'evalFormMargin': 'evalForm'} onClick={this.handleAssesment}>
        {toggle ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} ASSESMENT</h6>        
        <div className={toggle ? 'assesmentShow': 'assesmentHide'}>           
         <Table responsive className='readOnly'>        
          <thead>
            <tr className='Assesment'>
              <th>Parameters</th>
              <th>Attributes</th>
              <th>Questions</th>
              <th>Wtg.</th>
              <th>NA</th>
              {this.isRatingYes  ?  <th>Rating<br/>(Y/N)</th> : null}
              {this.isRating  ?   <th>Rating</th> : null}
              <th>Fatal</th>
              {this.isNCReason1 ?<th style={{'width':'100px'}}>NCReason 1</th> : null}
              {this.isNCReason2 ?<th style={{'width':'100px'}}>NCReason 2</th> : null}
              {this.isNCReason3 ?<th style={{'width':'100px'}}>NCReason 3</th>: null}
              {this.isNCReason4 ?<th style={{'width':'100px'}}>NCReason 4</th>: null}
              {this.isNCReason5 ?<th style={{'width':'100px'}}>NCReason 5</th>: null}
              <th style={{'width':'100px'}}>Feedback</th>
              </tr>
          </thead>
          <tbody>
            {
              this.renderBody()
            }
        </tbody>
        </Table>
        </div>     
        {(!_.isEmpty(this.props.ScoreCalculation) && typeof this.props.ScoreCalculation !== 'undefined') ? 
        <div>       
        <h6 className={toggleS ? 'evalFormMargin': 'evalForm'} onClick={this.handleScoreCalculation}>
        {toggleS ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}SCORE CALCULATION</h6> 
        <div className={toggleS ? 'assesmentShow': 'assesmentHide'}>
          <Table responsive className='noalternate'>
            <thead>
              <th>PARAMETERS</th><th>ATTRIBUTES</th><th>QUESTIONS</th><th>MAX SCORE</th>
              <th>ACTUAL SCORE</th><th>QUESTION SCORE (in %)</th><th>ATTRIBUTE SCORE (in %)</th><th>PARAMETER SCORE (in %)</th>
            </thead>
            <tbody>
              {this.ScoreCalculation(this.props.ScoreCalculation)}
            </tbody>
          </Table>
        </div> 
        </div>
        : null }   
        
        
        <h6 className={toggleF ? 'evalFormMargin': 'evalForm'} onClick={this.handleFeedbackToggle}>{toggleF ?
           <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} FEEDBACK</h6> 
        <div className={toggleF ? 'assesmentShow': 'assesmentHide'}>
        <Row className='auditor_Feedback'>
        <Col>
        <b>Auditor's Feedback</b><br/>
        <label>{this.props.auditorJson.templateValue.Readonly.FinalFeedback}</label><br/>
        <b> QA Name </b> <br/>  {this.props.auditorJson.templateValue.Readonly.QAName}
        </Col>
        <Col>    
        <b> Evaluated Date </b><br/> {this.props.auditorJson.templateValue.Readonly.EvaluationDate}<br/>
        </Col>
        </Row>
        </div>
      </div>
    )
  }
}